import React from "react";
import PropTypes from "prop-types";
import axios from 'axios';
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import DoneOutline from "@material-ui/icons/DoneOutline";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Table from "components/Table/Table.jsx";
import Tasks from "components/Tasks/Tasks.jsx";
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import Danger from "components/Typography/Danger.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Chip from '@material-ui/core/Chip';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

import Button from "components/CustomButtons/Button.jsx";
import Tooltip from '@material-ui/core/Tooltip';

import moment from 'moment';
import 'moment/locale/is';

import { bugs, website, server } from "variables/general.jsx";
import { Processing } from "../../baseparking-api";

import {
  dailySalesChart,
  emailsSubscriptionChart,
  completedTasksChart
} from "variables/charts.jsx";

function formatISK(price) {
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

const dashboardStyle = {
  subTitle: {
    color: 'black',
    paddingTop: '10px',
  },
  infoText: {
    position: 'absolute',
    width: '50%',
    float: 'right',
    margin: '0',
    padding: '0',
    right: '0',
    bottom: '-19px',
    color: '#c3c3c3',
  },
  inboundButton: {
    borderRadius: '100px',
    border: '1px solid gray',
    color: 'black',
    cursor: 'pointer',
    padding: '6px 11px',
    backgroundColor: 'transparent',
  },
  outboundButton: {
    borderRadius: '100px',
    border: '1px solid gray',
    color: 'black',
    cursor: 'pointer',
    padding: '6px 11px',
    backgroundColor: 'transparent',
  },
  services: {
    justifyContent: 'flex-start',
    marginTop: '-10px',
  },
  chip: {
    backgroundColor: '#e2e2e2',
    marginRight: '10px',
  },
  serviceHandler: {
    position: 'absolute',
    top: '100px',
    right: '20px',
    display: 'flex',
    flexDirection: 'flex-row',
  },
  paymentStatus: {

  },
  paid: {
    margin: 0,
    backgroundColor: 'green',
    color: 'white',
    padding: '5px 10px',
    borderRadius: '1000px',
  },
  notpaid: {
    margin: 0,
    border: '1px solid red',
    padding: '5px 10px',
    borderRadius: '1000px',
  },
};

class ProcessingView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      inbound: [],
      outbound: [],
      serviceFilter: false,
      l1: true,
      l2: true,
      l3: true,
    };

    Processing.getCarsIn()
      .then(res => {
        this.setState({ inbound: res.data.orders.filter(o => !o.status || o.status === 'paid'), l1: false });
      })
      .catch(console.error)

    Processing.getCarsOut()
      .then(res => {
        this.setState({ outbound: res.data.orders.filter(o => !o.status || o.status === 'paid'), l2: false });
      })
      .catch(console.error)

    Processing.getFlights()
      .then(res => {
        const { flights } = res.data;
        this.setState({ flights, l3: false });
        // this.setState({
        //   kefDepatures: flights.filter(f => f.departure),
        //   kefArrivals: flights.filter(f => !f.departure),
        // })
      })
      .catch(console.error);
  }

  componentWillMount() {

  }


  markArrived = order => {
    Processing.markArrived(order._id)
      .then(res => {
        if (window.confirm(`Ertu alveg viss um að bíll: ${order.vehicle.reg} sé kominn inn.`)) {
          let { inbound, outbound } = this.state;
          outbound.push(order);
          outbound.sort((a, b) => moment(a.stay.arrival).valueOf() - moment(b.stay.arrival).valueOf());
          inbound = inbound.filter(o => o._id !== order._id);
          this.setState({ inbound, outbound });
        }
      })
      .catch(err => {
        console.error(err);
      })
  }

  markReturned = order => {
    if (window.confirm(`Ertu alveg viss um að bíll: ${order.vehicle.reg} sé kominn afgreiddur.`)) {
      Processing.markReturned(order._id)
        .then(res => {
          let { outbound } = this.state;
          outbound = outbound.filter(o => o._id !== order._id);
          this.setState({ outbound });
        })
        .catch(err => {
          console.error(err);
        })
    }
  }


  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  getFlightStatus = flightNumber => {
    const { flights } = this.state;
    return flights && flights.find(f => f.No === flightNumber);
  }

  render() {
    const { classes } = this.props;
    const { outbound, inbound, serviceFilter, l1, l2, l3 } = this.state;
    let ob = outbound;
    let ib = inbound;

    if (l1 || l2) return <p>loading</p>;
    if (serviceFilter) {
      ob = ob.filter(b => b.services && b.services.length);
      ib = ib.filter(b => b.services && b.services.length);
    }
    return (
      <div>
        <div className={classes.serviceHandler}>
          <p>Einungis sýna bíla með aukaþjónustum: </p>
          <Checkbox
            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
            checkedIcon={<CheckBoxIcon fontSize="small" />}
            value={serviceFilter}
            onChange={e => this.setState({ serviceFilter: !serviceFilter })}
          />
        </div>
        <GridContainer>
          <GridItem xs={12} sm={6} md={6}>
            <p>Bílar á leið inn</p>
            {
              ib.map(order => {
                const flight = this.getFlightStatus(order.stay.flightNumber);
                let flightInfo = '';
                if (flight) {
                  let e = flight.Estimated || flight.Scheduled;
                  flightInfo = moment(e.slice(0, e.length - 6)).format('MM.DD HH:mm');
                }
                if (!flightInfo) {
                  flightInfo = 'Brottför fannst ekki'
                }
                return (
                  <Card>
                    <CardHeader color={moment().diff(order.stay.departure) > 0 ? "danger" : moment().diff(order.stay.departure, 'days') === 0 ? "warning" : "primary"} stats icon>
                      <CardIcon color={moment().diff(order.stay.departure) > 0 ? "danger" : moment().diff(order.stay.departure, 'days') === 0 ? "warning" : "primary"}>
                        <b>{order.client.vip ? '🏆' : order.client.senior ? '👵' : ''} {order.vehicle.reg} </b>- {order.vehicle.make}, {order.vehicle.type} ({order.vehicle.color})
                      </CardIcon>
                      <h6 className={classes.subTitle}>{moment(order.stay.departure).fromNow()} <b>({moment(order.stay.departure).format('DD.MM - HH:mm')})</b></h6>
                      <p className={classes.infoText}>
                        <b>{order.stay.flightNumber}</b> - {flightInfo}
                      </p>
                    </CardHeader>
                    <CardFooter stats>
                      <p>{order.client.name} - <b>{order.client.phone}</b> - {order.client.email} - <b> ISK {formatISK(order.totalPrice)} </b></p>
                      <button className={classes.inboundButton} onClick={e => this.markArrived(order)}>Bíll móttekinn</button>
                      {/* <Tooltip title={'Smelltu hér ef að bíllinn er kominn í hlað.'}>
                        <Button color={'warning'} onClick={e => console.log('submitting car')}>
                          <DoneOutline style={{ marginTop: '-5px' }} />
                        </Button>
                      </Tooltip> */}
                    </CardFooter>
                    {
                      !!order.services.length &&
                      <CardFooter className={classes.services}>
                        {
                          order.services.map(service => <Chip className={classes.chip} label={service.labelThen} />)
                        }
                      </CardFooter>
                    }
                  </Card>
                )
              }
              )
            }
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            <p>Bílar í geymslu</p>
            {
              ob.map(order => {
                const flight = this.getFlightStatus(order.stay.flightNumber);
                let flightInfo = '';
                if (flight) {
                  let e = flight.Estimated || flight.Scheduled;
                  flightInfo = moment(e.slice(0, e.length - 6)).format('MM.DD HH:mm');
                }
                if (!flightInfo) {
                  flightInfo = 'Koma fannst ekki'
                }
                return (
                  <Card>
                    <CardHeader color={moment().diff(order.stay.arrival) > 0 ? "danger" : moment().diff(order.stay.arrival, 'days') === 0 ? "warning" : "success"} stats icon>
                      <CardIcon color={moment().diff(order.stay.arrival) > 0 ? "danger" : moment().diff(order.stay.arrival, 'days') === 0 ? "warning" : "success"}>
                        <b>{order.client.vip ? '🏆' : order.client.senior ? '👵' : ''} {order.vehicle.reg} </b>- {order.vehicle.make}, {order.vehicle.type} ({order.vehicle.color})
                        <p className={classes.infoText}>
                          <b>{order.stay.flightNumber}</b> - {flightInfo}
                        </p>
                      </CardIcon>
                      <h6 className={classes.subTitle}>{moment(order.stay.arrival).fromNow()} <b>({moment(order.stay.arrival).format('DD.MM - HH:mm')})</b></h6>
                    </CardHeader>
                    <CardFooter stats>
                      <p>{order.paymentMethod ? <b className={classes.paid}>Greitt</b> : <b className={classes.notpaid}>Ógreitt</b>} - {order.client.name} - <b>{order.client.phone}</b> - {order.client.email} - <b> ISK {formatISK(order.totalPrice)} </b></p>
                      <button className={classes.outboundButton} onClick={e => this.markReturned(order)}>Bíll afgreiddur</button>
                    </CardFooter>
                    {
                      !!order.services.length &&
                      <CardFooter className={classes.services}>
                        {
                          order.services.map(service => <Chip className={classes.chip} label={service.labelThen} />)
                        }
                      </CardFooter>
                    }
                  </Card>
                )
              })
            }
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

ProcessingView.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(dashboardStyle)(ProcessingView);


// WEBPACK FOOTER //
// ./src/views/Processing/Processing.jsx